import classes from './App.module.css';
import MenuHeaders from './components/MenuHeaders';
import { useState } from 'react';
import Drinks from './components/drinks/Drinks';
import Foods from './components/pizza/Foods';
import Shakes from './components/shakes/Shake';
import Coctails from './components/fastfood/Coctails';
import MainFoods from './components/coctails/MainFoods';
import Colas from './components/colas/Colas';

const App = () => {

  const [ showDrinks , SetshowDrinks ] = useState (false);
  const [ showFoods , SetshowFoods ] = useState (false);
  const [ showShakes , SetShowShakes ] = useState(false);
  const [ showCoctails , SetShowCoctails ] = useState(false);
  const[showMainFoods , SetShowMainFoods] = useState(false);
  const [showColas , SetShowColas ] = useState(false);



const ShowDrinksHandler = () => {
    SetshowDrinks(true);
}

const ShowFoodHandler = () => {
  SetshowFoods(true);
}

const ShowShakeHandler = () =>{
  SetShowShakes(true);
}

const  ShowCoctailHandler = () => {
 SetShowCoctails(true);
}

const ShowMainFoodsHandler = () => {
  SetShowMainFoods(true);
}
const ShowColasHandler = () => {
SetShowColas(true);
}

const CloseItemHandler = () => {
   
  SetshowDrinks(false);
  SetshowFoods(false);
  SetShowShakes(false);
  SetShowCoctails(false);
  SetShowMainFoods(false);
  SetShowColas(false);
}


return (
<div className={classes.app} >
    <p className={classes.header}>Lorem  </p>

{!showShakes && !showDrinks && !showFoods && !showCoctails && !showMainFoods && !showColas && <MenuHeaders OnShowDrinks={ ShowDrinksHandler } OnShowFoods={ ShowFoodHandler } OnShowShakes={ShowShakeHandler} OnShowCoctails={ ShowCoctailHandler } OnShowMainFoods={ShowMainFoodsHandler} OnShowColas={ShowColasHandler}/>}

{showDrinks && <Drinks onClick={CloseItemHandler} />}
{showFoods  && <Foods onClick={CloseItemHandler}  />}
{showShakes && <Shakes onClick={CloseItemHandler} />}
{showCoctails && <Coctails onClick={ CloseItemHandler}/>}
{showMainFoods && <MainFoods onClick={CloseItemHandler}/>}
{showColas && <Colas onClick = {CloseItemHandler} />}
</div>

)
  
};

export default App;
